import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import Menu from './Menu';
import cm from 'helpers/commons';
import storage from 'helpers/storage';
import BookMarkMenu from './BookMarkMenu';
import { Header, Table, Rating, Icon, Dropdown } from 'semantic-ui-react';
import { tag } from 'images/companyEvent';

import * as auth from 'actions/auth';
import * as bookMark from 'actions/bookMark';

const propTypes = {};

const defaultProps = {};

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      level: null,
      companyList: null
    };
  }

  componentWillMount() {
    const company = storage.get('company');
    let companyList = null;

    if (company.user.level === 99) {
      companyList = cm.selectDataForMat(company.list);
    }

    this.setState({
      level: company.user.level,
      companyList: companyList
    });
  }

  handleChange = async (e, data) => {
    const { authAction, bookMark } = this.props;
    //company me 호출

    try {
      const { company } = this.props;

      storage.set('company', {
        userID: company.data.user.id,
        user: company.data.user,
        id: data.value,
        info: company.data.user.company,
        list: company.data.company
      });
      location.href = '/main/dashBoard';
    } catch (e) {
      console.log('###### handleChange error : ', e);
    } finally {
    }
  };
  render() {
    let bookMarkMenu = [];
    const { level, companyList } = this.state;
    const { listResult, lnbMenuFn, menu, company } = this.props;

    if (cm.valueCheck(listResult)) {
      return null;
    }

    let url = this.context.router.history.location.pathname;
    let auth = null;

    if (company && company.data) {
      auth = company.data.auth.auth;
    }
    const isApproval = ((storage.get('company') || {}).user || {}).isApproval; //청구서 소유여부
    const depth1 = menu.depth1.map((data, idx) => {
      let isActive = data.url === url ? true : false;
      let cName = data.code === '500' ? 'lnb-group dashboard' : 'lnb-group border';
      if (isActive) {
        cName += ' active';
      }
      cm.isMenuView(data, auth);
      //기타관리 메뉴 권한이 없지만 isApproval(청구서 소유여부)이 있는 경우 노출 시킨다.
      if (data.code === '400' && isApproval) {
        data.isShow = true;
      }

      try {
        //우수 고객사 혜택보기
        const { bookMarkAdd, bookMarkDel } = this.props.lnbMenuFn;
        let isBookMark = false;
        if (listResult && listResult.data && listResult.data.favorite) {
          listResult.data.favorite.forEach((item) => {
            if (data.code == item.code) {
              isBookMark = true;
              data['idx'] = item.idx;
              bookMarkMenu.push(data);
              return;
            }
          });
        }

        if (data.isLink) {
          return (
            <li className={isActive ? 'menu-active' : ''} key={data.code} style={{ textAlign: 'left' }}>
              <div
                onClick={(e) => {
                  lnbMenuFn.lnbMenuClick(data);
                }}
              >
                <a
                  style={{
                    color: 'white',
                    padding: '6px 0px 7px 16px',
                    fontSize: 14,
                    opacity: 1,
                    fontWeight: 700,
                    lineHeight: 2.5
                  }}
                >
                  {data.name}
                </a>
                {/* new 뱃지 적용하는 곳 */}
                {/* {data.code === 81 ? (
                  <img
                    src={tag}
                    alt="new-badge"
                    style={{ width: '35px', verticalAlign: 'middle', marginLeft: 7, marginBottom: 3 }}
                  />
                ) : null} */}
              </div>
              <Icon
                name="star"
                size="small"
                color={isBookMark ? 'green' : 'grey'}
                onClick={() => bookMarkAdd(data.code, isBookMark)}
                style={{ float: 'right', margin: '18px' }}
              />
            </li>
          );
        }
      } catch (e) {}

      return data.isShow ? (
        <div key={data.code}>
          <div
            className={cName}
            onClick={data.code === '500' ? (e) => lnbMenuFn.lnbMenuClick(data) : (e) => lnbMenuFn.lnbDepth2OnOff(idx)}
          >
            <span>{data.name}</span>

            {data.code !== '500' ? (
              <Icon
                className="depth1-icon"
                name={data.isOpen ? 'minus' : 'plus'}
                onClick={(e) => lnbMenuFn.lnbDepth2OnOff(idx)}
              />
            ) : null}
          </div>
          {data.isOpen ? <Menu depth2={data.depth2} lnbMenuFn={lnbMenuFn} /> : null}
        </div>
      ) : null;
    });

    if (listResult && listResult.data && listResult.data.favorite) {
      listResult.data.favorite.forEach((data) => {
        menu.depth1.map((menu) => {
          menu.depth2.forEach((depth2) => {
            if (data.code == depth2.code && depth2.isShow) {
              depth2['idx'] = data.idx;
              bookMarkMenu.push(depth2);
              return;
            }
          });
        });
      });
    }

    const style = {
      selectbox: {
        width: '95%',
        marginLeft: '5px'
      },
      lnbTitle: {}
    };

    if (level === 99) {
      style['lnbTitle'] = {
        height: '115px'
      };
    }

    return (
      <div className="">
        {bookMarkMenu.length > 0 ? (
          <div className="lnb-group border">
            <span>즐겨찾기</span>
          </div>
        ) : null}

        <div>
          <BookMarkMenu menu={bookMarkMenu} lnbMenuFn={lnbMenuFn} />
        </div>
        {depth1}
      </div>
    );
  }
}

List.propTypes = propTypes;
List.defaultProps = defaultProps;

List.contextTypes = {
  router: PropTypes.object.isRequired
};

List = connect(
  (state) => ({
    listResult: state.bookMark.listResult,
    company: state.auth.company
  }),
  (dispatch) => ({
    bookMark: bindActionCreators(
      {
        list: bookMark.List
      },
      dispatch
    )
  })
)(List);

export default List;
